import { render, staticRenderFns } from "./tradeOrderSymbolDataPart.vue?vue&type=template&id=345828e4&scoped=true&"
import script from "./tradeOrderSymbolDataPart.vue?vue&type=script&lang=js&"
export * from "./tradeOrderSymbolDataPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345828e4",
  null
  
)

export default component.exports